import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import useCallApi from "../../hooks/useCallApi";
import { Routes } from "../../routes/Routes";
import { useAlert } from "../../context/AlertContext";
import { useContent } from "../../content/useContent";
import { useRTL } from "../../hooks/useLanguage/useRTL";
import GameApi from "../../api/game";

const useEventsContainer = () => {
  const navigate = useNavigate();
  const { callApi, loading } = useCallApi();
  const { setSuccessMessage } = useAlert();
  const { isRTL } = useRTL();

  const { games } = useContent().pages;

  const [pageLoading, setPageLoading] = useState(true);

  const [allGames, setAllGames] = useState([]);
  const [searchedGames, setSearchedGames] = useState([]);

  const [searchValue, setSearchValue] = useState("");

  const [selected, setSelected] = useState<any>(null);

  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  const [page, setPage] = useState(1);
  const [rowsPerPage] = useState(6);

  const handleChangePage = (
    game: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setPage(value);
  };

  useEffect(() => {
    setPageLoading(true);
    callApi(GameApi.getAll(), (games: any) => {
      setAllGames(games);
      setSearchedGames(games);
      setPageLoading(false);
    });
  }, [isRTL]);

  const handleSearch = (value: string) => {
    setSearchValue(value);
    setPage(1);
    if (value.trim() === "") {
      setSearchedGames(allGames);
    } else {
      setSearchedGames(
        allGames.filter((game: any) =>
          game.title.toLowerCase().includes(value.toLowerCase())
        )
      );
    }
  };

  const handleOpenDelete = (row: any) => {
    setSelected(row);
    setOpenDeleteDialog(true);
  };

  const handleClick = (id: string) => {
    navigate(Routes.getGame(id));
  };

  return {
    games: searchedGames,
    handleSearch,
    searchValue,
    pageLoading,
    page,
    handleChangePage,
    rowsPerPage,
    handleClick,

    handleOpenDelete,
    selected,
    openDeleteDialog,
    setOpenDeleteDialog,
    loading,
  };
};

export default useEventsContainer;
